import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFilter from "../../../../../hook/useFilter";
import { fileActions } from "../../../../../store/files-slice";

export default function Resort({ type, name }) {
    const filteredFiles = useSelector(state => state.file.filteredfiles);
    const files = useSelector(state => state.file.files);
    const dispatch = useDispatch();
    const { resort } = useFilter();

    return <Fragment>
        <label htmlFor={`file-sort-${type}`}>{name}</label>
        <select id={`file-sort-${type}`} className="form-select mb-2" defaultValue="" onChange={event => {
            if (event.target.value) dispatch(fileActions.setFilteredItems(resort(filteredFiles ?? files, type, event.target.value)));
        }}>
            <option value="">Sort</option>
            <option value="ASC">Ascending</option>
            <option value="DESC">Descending</option>
        </select>
    </Fragment>;
}
